import makeService from './api';

export default makeService('material_feed_specs');
